'use strict';

// prevent the form element from becoming invalid until a blur event has occurred
// we insert a formatter and a parser that run last in their chains. They reset all errors until a blur event was recorded.
angular.module('um.commonDirectives').directive('validUntilTouched', [function() {
    return {
        require: ['ngModel', '^form'],  // request 2 controllers in the 4th argument of the link function
        priority: 10,   // make sure, the link function runs after all (default priority 0) angular validation directives
        link: function($scope, element, attrs, ctrl) {
            var ngModelCtrl = ctrl[0];
            element.bind('blur', function() {
                ngModelCtrl.$touched = true;
                ngModelCtrl.$setViewValue(ngModelCtrl.$viewValue);
                $scope.$apply();
            });

            // validation should also apply when the field is emptied, so also check onKeyUp
            element.bind('keyup', function() {
                if (!ngModelCtrl.$viewValue && ngModelCtrl.$dirty) {
                    ngModelCtrl.$touched = true;
                    ngModelCtrl.$setViewValue(ngModelCtrl.$viewValue);
                    $scope.$apply();
                }
            });

            // append to parsers. Parsers are run in the order of the $parsers array
            ngModelCtrl.$parsers.push(function(viewValue) {
                if (!ngModelCtrl.$touched) {
                    _.forOwn(ngModelCtrl.$error, function(val, key) {
                        ngModelCtrl.$setValidity(key, true);
                    });
                }
                return viewValue;  // always update the model. Returning undefined would not update the model
            });
            // just in case somebody updates the model
            // insert as the first formatter. formatters are run in the reverse order of the $formatters array
            ngModelCtrl.$formatters.unshift(function(value) {
                if (!ngModelCtrl.$touched) {
                    _.forOwn(ngModelCtrl.$error, function(val, key) {
                        ngModelCtrl.$setValidity(key, true);
                    });
                }
                // return the value or nothing will be written to the DOM.
                return value;
            });
        }
    };
}]);
